import AdminPage from '@pages/AdminPage';
import HomePage from '@pages/HomePage';
import NotFoundPage from '@pages/NotFoundPage';
import { initCsrf } from '@services/api';
import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import './App.css';

/**
 * Main App component with routing setup
 */
function App(): JSX.Element {
  // Initialize CSRF protection on app mount
  useEffect(() => {
    initCsrf();
  }, []);

  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<HomePage />} />

        {/* Admin routes */}
        <Route path="/admin/*" element={<AdminPage />} />

        {/* 404 route */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;
